let tmpNoteall = require('../mobileJson/noteall.json');  // 所有日志
let tmpNoteService = require('../mobileJson/noteservice.json');  // 业务信息
let tmpNotepropety = require('../mobileJson/noteproperty.json');  // 日志属性
let tmpNotedevice = require('../mobileJson/notedevice.json'); // 设备属性

export default {
    install(Vue, options) {
        Vue.prototype.dealMobileData = function (itemData) {
            let noteAll = [];       // 所有日志
            let noteService = [];   // 业务属性
            let noteProperty = [];  // 日志属性
            let noteDevice = [];    // 设备属性
            let noteOther = [];     // 其他
            let recordKeys = [];   // 记录查询到的数组值
            let mobileData = new Object();  //  处理传入数据
            // let noteType = '';
            let tmpItemData = Object.assign({}, itemData);  // 进行深拷贝，以达到和原数据进行解耦的目的

            for (let j = 0, len = tmpNoteall.length; j < len; j++) { // 处理所有的日志
                let item = tmpNoteall[j];
                Object.keys(itemData).forEach(function (key) {
                    if (key == item["fieldName"]) {
                        let appObtain = item["appObtain"] ? "SDK获取" : "APP传入";

                        if (key == 'rtm') {
                            appObtain = "服务端生成";
                        }
                        if (key == 'clt') {
                            if (itemData[key] == 'app') {
                                mobileData.isApp = true;
                            } else {
                                mobileData.isApp = false;
                            }
                        }
                        recordKeys.push(key);
                        if (!verifythekey(key)) {
                            noteAll.push({
                                fieldName: key,
                                fieldDes: item["fieldDes"],
                                fieldValue: itemData[key],
                                fieldObt: appObtain
                            });
                        }
                    }
                });
            }

            for (let j = 0, len = tmpNoteService.length; j < len; j++) { // 处理业务属性字段
                let item = tmpNoteService[j];
                Object.keys(itemData).forEach(function (key) {
                    let fieldValueName = itemData[key];
                    if (key == item["fieldName"]) {
                        let appObtain = item["appObtain"] ? "SDK获取" : "APP传入";
                        if (key == 'rtm') {
                            appObtain = "服务端生成";
                        }
                        if (!verifythekey(key)) {
                            noteService.push({
                                fieldName: key,
                                fieldDes: item["fieldDes"],
                                fieldValue: itemData[key],
                                fieldObt: appObtain
                            });
                        }
                    }
                });
            }

            for (let j = 0, len = tmpNotepropety.length; j < len; j++) {  // 处理日志属性
                let item = tmpNotepropety[j];
                Object.keys(itemData).forEach(function (key) {
                    let fieldValueName = "";
                    if (key == item["fieldName"]) {
                        let appObtain = item["appObtain"] ? "SDK获取" : "APP传入";
                        if (!verifythekey(key)) {
                            noteProperty.push({
                                fieldName: key,
                                fieldDes: item["fieldDes"],
                                fieldValue: itemData[key],
                                fieldObt: appObtain
                            });
                        }
                    }
                });
            }

            for (let j = 0, len = tmpNotedevice.length; j < len; j++) {  // 处理设备属性字段
                let item = tmpNotedevice[j];
                Object.keys(itemData).forEach(function (key) {
                    let fieldValueName = itemData[key];
                    if (key == item["fieldName"]) {
                        let appObtain = item["appObtain"] ? "SDK获取" : "APP传入";
                        noteDevice.push({
                            fieldName: key,
                            fieldDes: item["fieldDes"],
                            fieldValue: itemData[key],
                            fieldObt: appObtain
                        });
                    }
                });
            }

            let tempItemDataKeys = removeRepetitiveKey(recordKeys.concat(Object.keys(itemData)));  //数组拼接并将多余的数组展示出来
            for (let j = 0, len = tempItemDataKeys.length; j < len; j++) {  // 处理其他属性字段
                let recordKey = tempItemDataKeys[j];
                if (verifythekey(recordKey)) {
                    continue;
                }
                noteOther.push({
                    fieldName: recordKey,
                    fieldDes: "",
                    fieldValue: itemData[recordKey],
                    fieldObt: "APP传入"
                });
            }

            mobileData.noteService = noteService;
            mobileData.noteProperty = noteProperty;
            mobileData.noteDevice = noteDevice;
            mobileData.noteOther = noteOther;
            mobileData.noteAll = noteAll.concat(noteOther);
            mobileData.original = dealElement(tmpItemData);

            return mobileData;
        }

        function dealElement(obj) {
            let param = {};
            if (obj === null || obj === undefined || obj === "") return param;
            for (let key in obj) {
                if (verifythekey(key)) {
                    continue;
                }
                param[key] = obj[key];
            }
            return JSON.stringify(param, undefined, 2);
        }

        function removeRepetitiveKey(arr) {
            var newArray = [];
            for (var i = 0; i < arr.length; i++) {
                var count = 0;
                for (var j = 0; j < arr.length; j++) {
                    if (arr[i] == arr[j]) {
                        count++;
                    }
                }
                if (count == 1) {
                    newArray.push(arr[i]);
                }
            }
            return newArray;
        }

        function verifythekey(key) { // 判断key是否是自己手动添加的
            if (key == 'debugId' || key == 'id' || key == 'tmptyp' || key == 'tmpctp' || key == 'tmppar' || key == 'tmppageid') {
                return true;
            }
            return false;
        }

        // function syntaxHighlight(json) {  // 处理源数据
        //     if (typeof json != 'string') {
        //         json = JSON.stringify(json, undefined, 2);
        //     }
        //     json = json.replace(/&/g, '&').replace(/</g, '<').replace(/>/g, '>');
        //     return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g,
        //         function (match) {
        //             var cls = 'number';
        //             if (/^"/.test(match)) {
        //                 if (/:$/.test(match)) {
        //                     cls = 'key';
        //                 } else {
        //                     cls = 'string';
        //                 }
        //             } else if (/true|false/.test(match)) {
        //                 cls = 'boolean';
        //             } else if (/null/.test(match)) {
        //                 cls = 'null';
        //             }
        //             return '<span class="' + cls + '">' + match + '</span>';
        //         });
        // }

        // function checkKeyword(str) {  // 统一处理返回的数据
        //     if (str == "" || str == undefined || str == null) return true;
        //     let reg = "^[ ]+$";
        //     let re = new RegExp(reg);
        //     return re.test(str);
        // }
    }
}
